import { Router, RouteData, NavigationRoute } from 'shared-utils';
import { getYearRouteParam } from 'utils/yearStore';
import PlotScreen from './PlotScreen';

export const PlotNavigation = (): NavigationRoute => new NavigationRoute(
    PlotScreen.key,
    [getYearRouteParam()]
);

const router = new Router();

router
    .add(new RouteData({
        key: PlotScreen.key,
        path: '',
        component: PlotScreen,
        exact: true,
        metadata: {
            authRequired: true,
            rolesAllowed: ['administrator', 'supervisor', 'writer']
        }
    }));

export default router;